import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import Button from "../../../../componentes/button/button";

// Confirmação específica para o atalho "produto já em estoque" na Etapa 3 (Cotação) — encerra a
// solicitação diretamente, sem passar pelas etapas de Aprovação Corporativa, Ordem de Compra e
// Recebimento. Ação irreversível pelo fluxo normal, por isso o modal dedicado (não reaproveita o
// EncaminhamentoSidebar genérico, já que não há "próxima etapa"/responsável a escolher aqui).
// Exige que o usuário redigite o número da solicitação para confirmar — só então o botão de
// finalizar é habilitado, evitando cliques acidentais numa ação irreversível.
export default function FinalizarPorEstoqueModal({ visible, solicitacao, enviando, onFechar, onConfirmar }) {
    const [numeroDigitado, setNumeroDigitado] = useState("");

    useEffect(() => {
        if (!visible) setNumeroDigitado("");
    }, [visible]);

    if (!solicitacao) return null;

    const confirmado = numeroDigitado.trim() === solicitacao.numero;

    return (
        <Dialog
            header="Finalizar Solicitação — Produto em Estoque"
            visible={visible}
            onHide={enviando ? () => {} : onFechar}
            blockScroll
            className="w-[95%] max-w-lg"
            footer={
                <div className="flex justify-end gap-3">
                    <Button variant="outline" label="Voltar" onClick={onFechar} disabled={enviando} />
                    <Button
                        variant="green"
                        label="Finalizar Solicitação"
                        iconLeft="fa fa-check-circle"
                        loading={enviando}
                        disabled={!confirmado}
                        onClick={onConfirmar}
                    />
                </div>
            }
        >
            <div className="p-4 pb-0 flex flex-col gap-4">
                <p className="text-sm text-foreground">
                    Tem certeza que deseja finalizar esta solicitação sem realizar a compra?
                </p>

                <div className="grid grid-cols-2 gap-3 text-sm rounded-lg bg-muted px-4 py-3">
                    <div>
                        <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Solicitação</span>
                        <span className="block text-foreground font-medium">{solicitacao.numero}</span>
                    </div>
                </div>

                <p className="text-xs text-muted-foreground">
                    <i className="fa fa-info-circle mr-1" />
                    O produto informado já possui estoque disponível — a solicitação será encerrada
                    diretamente, sem passar pelas etapas de Aprovação Corporativa, Ordem de Compra e Recebimento.
                </p>

                <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-medium text-foreground/80">
                        Digite o número da solicitação (<span className="font-semibold">{solicitacao.numero}</span>) para confirmar
                    </label>
                    <input
                        type="text"
                        value={numeroDigitado}
                        onChange={e => setNumeroDigitado(e.target.value)}
                        disabled={enviando}
                        placeholder={solicitacao.numero}
                        className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                    />
                </div>
            </div>
        </Dialog>
    );
}
